
import Vue from 'vue';
import _ from 'lodash';
import { TranslationService } from '@/services/TranslationService';
import { customerAlias } from '@/helpers/customerAlias';
import { dateFormat } from '@/helpers/dateFormat';
import { numFormat } from '@/helpers/numFormat';
import { productAlias } from '@/helpers/productAlias';
import { orderTarget } from '@/helpers/orderTarget';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} }
  },
  data: () => ({
    balanceQuantity: 0
  }),
  computed: {
    orderDetails: function(): any {
      return this.getVariable(this.input.variable);
    },
    noOfPieces: function (): number | null {
      if(this.orderDetails && this.orderDetails.product) {
        const sellingUnit = _.get(this.orderDetails, 'unit.unit2');
        let noOfPieces = this.orderDetails.quantity + (this.orderDetails.FOC || 0);
        _.forEach(this.orderDetails.product.packingMode, (packingModeItem: any) => {
          if(packingModeItem.unit1 === sellingUnit) {
            return false;
          }
          noOfPieces = noOfPieces * packingModeItem.quantity;
          if(packingModeItem.unit2 === sellingUnit) {
            return false;
          }
        })
        return noOfPieces ? noOfPieces :  null;

      }
      return null;
    },
    baseUnit: function (): string {
      const baseUnit = this.orderDetails.product.packingMode[0].unit1;
      return baseUnit || 'pieces';
    },
    sellingUnitBreakdown: function(): string {
      const sellingUnit = this.orderDetails.unit.unit2;
      const packingMode = this.orderDetails.product.packingMode;
      for(let i = 0; i < packingMode.length; i++) {
        if(sellingUnit == packingMode[i].unit1) {
          return `${sellingUnit} (1 ${sellingUnit})`;
        }
        if(sellingUnit == packingMode[i].unit2) {
          if(i == 0) {
            return `${sellingUnit} (${packingMode[i].quantity} ${packingMode[i].unit1} x 1 ${sellingUnit})`;
          } else {
            return `${sellingUnit} (${packingMode[0].quantity} ${packingMode[0].unit1} x ${packingMode[1].quantity} ${packingMode[1].unit1} x 1 ${sellingUnit})`;
          }
        }
      }
      return sellingUnit;
    },
    totalQuantityProduced: function(): number | undefined {
      if(_.get(this.input, 'config.totalQuantityProducedVariable')) {
        return this.getVariable(this.input.config.totalQuantityProducedVariable);
      } else {
        return undefined;
      }
    },
    averageProgress: function(): number | undefined {
      if(_.get(this.input, 'config.averageProgressVariable')) {
        return this.getVariable(this.input.config.averageProgressVariable);
      } else {
        return -1;
      }
    },
    customerAlias: function(): string {
      return customerAlias(this.orderDetails.customer);
    },
    productAlias: function(): string {
      return productAlias(this.orderDetails.product);
    },
    orderTargetStatus: function(): string {
      const targetArray = _.get(this.orderDetails, 'callOff.target', []);
      const orderTargetString = orderTarget(targetArray);
      if(orderTargetString == 'Unplanned' && ['Completed', 'Cancelled'].includes(this.orderDetails.status)) return '';
      return orderTargetString;
    }
  },
  watch: {
    totalQuantityProduced() {
      if(this.totalQuantityProduced !== undefined) {
        const totalOrderQuantity = this.orderDetails.quantity + (this.orderDetails.FOC || 0);
        this.balanceQuantity = totalOrderQuantity - this.totalQuantityProduced;
      }
    }
  },
  mounted() {
    this.$watch(
      () => this.orderDetails, 
      () => {
        this.checkForNumberOfTeeth();
      },
      {
        immediate: true
      }
    )
    
  },
  methods: {
    checkForNumberOfTeeth: function() {
      if(this.input.config && this.input.config.checkForNumberOfTeeth) {
        if(this.orderDetails.product.productLine === 'Baking Cup' && this.orderDetails.product.numberOfTeeth === 0) {
          this.parent._callMultipleFunctions(this.input.config.fnsAfterCheck)
        }
      }
    },
    translate: function(text: string): string {
      if(!text) return '';
      return TranslationService.translate(text);
    },
    formatDate(date: string): string {
      return dateFormat(date);
    },
    formatNumValues(numValue: number): string | number {
      return numFormat(numValue, true);
    }
  }
})
